<template>
  <div class="modal">
    <div class="modal__content">
      <h2 class="modal__head">{{msg}}</h2>

      <button class="ark-btn ark-btn--default" @click="onCloseModal">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoModal',
  props: ['msg', 'onCloseModal'],
  mounted () {
    if (this.$notify && this.msg) {
      this.$notify({ text: this.msg, type: 'info' })
    }
  }
}
</script>
